export default "__VITE_ASSET__qA2snwlz__"